/*
 * Author: Roger
 * File Created: Wednesday, 24-08-14 09:50 pm
 * Last Modified: Tuesday, 25-03-18 09:48 am, by Harper Yan
 */

import { useState } from 'react';
import type { FilledInputProps, FilledTextFieldProps, IconButtonProps, TextFieldProps } from '@mui/material';
import { Box, IconButton, InputAdornment } from '@mui/material';
import { Icon } from '@ucard/ds/Icon';
import type { mode } from './style';
import { StyledGoInput } from './style';
interface GoInputProps extends Omit<FilledTextFieldProps, 'value' | 'InputProps' | 'onChange' | 'variant'> {
  onSubmit: () => void;
  onChange: (_value: string) => void;
  buttonColor?: mode;
}
const GoInput: React.FC<GoInputProps> = ({
  onChange,
  buttonColor = 'main',
  onSubmit,
  ...inputProps
}) => {
  const [value, setValue] = useState<string>();
  const onValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const data = event.target.value;
    setValue(data);
    onChange(data);
  };
  return <StyledGoInput InputProps={{
    endAdornment: <InputAdornment position="end">
            <IconButton disabled={!value} onClick={onSubmit} sx={{
        width: ['32px!important', '38px!important'],
        height: ['32px', '38px']
      }}>
              <Icon name="ArrowForward" />
            </IconButton>
          </InputAdornment>
  }} onChange={onValueChange} placeholder="Enter your invitation code" {...inputProps} colorMode={buttonColor} data-sentry-element="StyledGoInput" data-sentry-component="GoInput" data-sentry-source-file="index.tsx" />;
};
export default GoInput;